import { inputTextLimit } from '../../../helpers/fieldRestriction';
import messages from '../../../locale/jsonMessages';

const validate = values => {
    const errors = {}

    if (!values.message) {
        errors.message = messages.messageRequired
    } else if (values.message.trim() == "") {
        errors.message = messages.messageRequired
    } else if (values.message && values.message.length > inputTextLimit) {
        errors.message = messages.inputTextLimitError;
    }

    return errors
}

export default validate;